/* eslint-disable */

import React, { FC, ReactElement, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import withLocalization from '../../components/hoc/withLocalization';
import EditLeadInfoDetails from '../../components/LeadInfoDetails/EditLeadInfoDetails';
import LeadInfoDetails from '../../components/LeadInfoDetails/LeadInfoDetails';
import OfferHeader from '../../components/common/OfferHeader/OfferHeader';
import { RootState } from '../../redux/rootReducer';
import { logAnalyticData, offerType } from '../../analytics';
import { useMediaQuery } from 'react-responsive';
import { Offer, OfferResponse } from '../offerSearch/types';
import NewOfferLoader from '../../components/common/NewOfferLoader/NewOfferLoader';
import { getSiteIdentifier } from '../../util/SiteDetails';
import { useCountryCodeByName } from '../../util/useCountryCodeByName';
import { getAllCountries } from '../../util/getCountriesDetails';
import { setCountriesData } from './PinOptFlowOfferSlice';

import './PinOptLeadInfoContainer.scss';
import isAsia from '../../util/isAsia';

const OfferValidateContainer: FC<any> = (props: any): ReactElement => {
  const { localizeImages } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  const { path } = localizeImages('preview-sales-engine.static-content.images.verify-page-hero', 0, '1:1');
  const mobPath = localizeImages('preview-sales-engine.static-content.images.verify-page-hero', 0, '7:3');
  const meDeskPath = localizeImages('preview-sales-engine.static-content.images.me-confirm-info-hero-image', 0, '4:5');
  const meMobPath = localizeImages('preview-sales-engine.static-content.images.me-confirm-info-hero-image', 0, '7:3');
  const asiaDeskPath = localizeImages(
    'preview-sales-engine.static-content.images.asia-confirm-info-hero-image',
    0,
    '4:5',
  );
  const asiaMobPath = localizeImages(
    'preview-sales-engine.static-content.images.asia-confirm-info-hero-image',
    0,
    '7:3',
  );
  const deskHeroPath = isAsia ? asiaDeskPath : meDeskPath;
  const mobHeroPath = isAsia ? asiaMobPath : meMobPath;
  const leadInfoDetails: any = useSelector((state: RootState) => state.offerDetails.prospect) || '';
  const isLoading = useSelector((state: RootState) => state.offerDetails.loading);
  const prspectPhone: any = useSelector((state: RootState) => state.offerDetails.nonFormatedCallcenterNo) || '';

  const offerDetails: OfferResponse = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const offer: Offer = (offerDetails?.offers && offerDetails.offers[0]) || '';
  const offerCode = offer?.offerCode || 'Vacation Offer';
  const callCenterNo = prspectPhone || '';
  const dialCode = useCountryCodeByName(leadInfoDetails?.countryCode);
  //const leadInfoPhNo = callCenterNo ? `${dialCode}${callCenterNo}` : '';
  const leadInfoPhNo = callCenterNo || '';
  const imgPath = isMobile ? mobHeroPath?.path : deskHeroPath?.path;
  const siteIdentifier = getSiteIdentifier();
  const errDetails = {
    errPhNo: prspectPhone || '',
    isPkgSold: false,
    errorCode: '',
    callCenterCode: leadInfoDetails?.callCenterCode,
    countryName: leadInfoDetails?.countryCode,
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const result = getAllCountries();
    dispatch(setCountriesData(result));
    if (!leadInfoDetails) navigate('/pin-error', { state: errDetails });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    logAnalyticData(
      {
        event: 'pbeVerifyPage',
        siteSection: 'MVC ' + siteIdentifier + 'Optimized PBE',
        pageName: 'MVC ' + siteIdentifier + 'PBE Verify Page',
        pageHierarchy: '',
        server: 'MVC',
        website: 'MVC react',
        language: 'en',
      },
      {
        errorMessage: '', //should we put the same error as displayed in pin-error page?,
        offerCode: offerCode,
        offerType: offerType(offer),
        flowldentifier: 'PIN',
        bookingStepName: 'MVC ' + siteIdentifier + '| PBE Verify Page',
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkEmptyFields = () => {
    const keysToCheck = ['email', 'phone'];
    for (let key of keysToCheck) {
      if (!leadInfoDetails[key] || leadInfoDetails[key] === '') {
        return false;
      }
    }
    return true;
  };
  const styleBg = {
    backgroundImage: `url("${imgPath}")`,
  };
  return (
    <>
      {isLoading && <NewOfferLoader />}
      <OfferHeader phone={leadInfoPhNo} isThankyou={false} />
      <div className="tmvc-leadInfo-Main-container">
        <div className="leadInfo-container">
          <div className="leadInfo-inner-container">
            {checkEmptyFields() ? (
              <LeadInfoDetails leadDetails={leadInfoDetails} />
            ) : (
              <EditLeadInfoDetails leadDetails={leadInfoDetails} />
            )}
          </div>
        </div>
        <div className="lead-main-img-wraper">
          <div className="pinFlowImg-bg-Lead" style={styleBg}></div>
        </div>
      </div>
    </>
  );
};
export default withLocalization(OfferValidateContainer);
